<section class="ai-section">
    <div class="container">
        <div class="card">
            <div class="page-header">
                <div>
                    <h3 class="page-title">AI Agents</h3>
                    <p class="page-subtitle">Agents per project: model, identity, website widget channels and test chat.</p>
                </div>
                <div class="flex-spacer"></div>
                <button *ngIf="perms.has(P.agentCreate)" class="btn-primary btn-inline" (click)="create()">
                    <i class="fa-solid fa-plus"></i> Create agent (support)
                </button>
            </div>

            <div class="info-note" role="note">
                <i class="fa-solid fa-circle-info"></i>
                <span>
                    Customers create and manage their agents in their own Dashboard, within their project plan.
                    Create and edit here are for GenAI support only.
                    <a *ngIf="perms.has(P.planList)" routerLink="/ai-agents/project-plans">Project plans</a>
                </span>
            </div>

            <div class="toolbar">
                <div class="form-field">
                    <label for="ag-project">Project</label>
                    <select id="ag-project" [(ngModel)]="projectFilter" (ngModelChange)="onProjectChange()">
                        <option value="">All projects</option>
                        <option *ngFor="let p of projects" [value]="p.projectId">{{ p.name }}</option>
                    </select>
                </div>
                <div class="form-field">
                    <label for="ag-search">Search</label>
                    <input id="ag-search" [(ngModel)]="search" placeholder="Name or ID" dir="auto" />
                </div>
            </div>

            <div class="table-wrapper table-mobile-card">
                <table class="table" id="ai-agents-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Project</th>
                            <th>Model</th>
                            <th class="status-col">Status</th>
                            <th class="date-col">Updated</th>
                            <th class="actions-wide">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="!loading && filtered.length === 0">
                            <td colspan="100%">
                                <div class="no-data"><i class="fa-solid fa-robot"></i> No agents found</div>
                            </td>
                        </tr>
                        <tr *ngFor="let a of filtered" class="clickable">
                            <td data-label="Name" (click)="open(a)">
                                <div class="copy-row">
                                    <img *ngIf="a.avatarUrl" [src]="a.avatarUrl" alt="" width="30" height="30" style="border-radius: 50%; object-fit: cover" />
                                    <strong dir="auto">{{ a.name }}</strong>
                                </div>
                            </td>
                            <td data-label="Project" (click)="open(a)">{{ projectName(a.projectId) }}</td>
                            <td data-label="Model" (click)="open(a)">{{ modelName(a.modelId) }}</td>
                            <td data-label="Status" class="status-col" (click)="open(a)">
                                <span class="badge" [ngClass]="a.status === 'ACTIVE' ? 'ok' : a.status === 'PAUSED' ? 'warn' : 'draft'">{{ a.status }}</span>
                            </td>
                            <td data-label="Updated" class="date-col">{{ a.updatedAt ? (a.updatedAt | date: 'MMM d, y') : '-' }}</td>
                            <td data-label="Actions" class="actions-wide">
                                <div class="actions-cell">
                                    <button class="icon-btn edit" title="Open" (click)="open(a)"><i class="fa-solid fa-pen"></i></button>
                                    <button *ngIf="perms.has(P.agentTest)" class="icon-btn create" title="Test chat" (click)="open(a, 'test')">
                                        <i class="fa-solid fa-comment-dots"></i>
                                    </button>
                                    <button *ngIf="perms.has(P.conversationList)" class="icon-btn view" title="Conversations" (click)="conversations(a)">
                                        <i class="fa-solid fa-comments"></i>
                                    </button>
                                    <button *ngIf="perms.has(P.agentDelete)" class="icon-btn delete" title="Delete" (click)="remove(a)">
                                        <i class="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>
